
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {amountUtils} from "../../assets/js/utils";
import Scroller from '../common/scroll/Scroller.vue'
import {DEVICE_RATIO,DOWN_CONFIG, UP_CONFIG} from '../common/scroll/base/js/config.js'

export default {
directives: {
TransferDom
},
components: {
GroupTitle,
Group,
Cell, CellBox, Flexbox, FlexboxItem,XDialog,Scroller
},
created (){
this.initPage();
},
computed:{
scrollElement(){
return this.$refs.scroll
}
},
methods: {
pullUpHandle(){
this.getInfo((res)=>{
this.scrollElement.PullingUpWord="加载完成";
setTimeout(()=>{
this.scrollElement.finish("PullUp");
this.dataList=this.dataList.concat(res.data.data.rows);
},1000)
})
},
initPage(){
this.dataList=[];
this.page=1;
this.getInfo((res)=>{
this.dataList=res.data.data.rows;
})
},
getInfo(callback){
let shopId = this.shopId;
let _this = this;
let uri = '/v1/shop/'+ shopId+"/bill/GET_SHOP_BILL_RECORD_LIST";
let params = {
"shopId":Number(shopId),
"billType":1, //民宿账单d
"currentPage":this.page,
"pageSize":this.pageSize,
"billNo": _this.$route.params.billNo,
};
_this.axios.post(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code != undefined && response.data.code == 0) {
_this.billInfo = response.data.data.billInfo;
callback&&callback(response);
_this.page++;
} else {
_this.showHideOnBlur = true;
_this.dialogMsg = response.data.msg;
}
}).catch(function (response) {
_this.showHideOnBlur = true;
_this.dialogMsg = response.message;
});
},
getDay(date){
let dateObj = new Date(date);
let result = dateObj.getDate();
return result<10?"0"+result:result;
},
getMonth(date){
let dateObj = new Date(date);
let result = dateObj.getMonth()+1;
return result<10?"0"+result:result;
},
getReportDate(date){
return this.getMonth(date)+"-"+this.getDay(date);
},
transform: amountUtils.transform
},
data () {
return {
dialogMsg: '',
showHideOnBlur:false,
dataList:[],
billInfo:{},
shopId: this.$route.params.shopId,
page:1,
pageSize:15,
pulldown: true,
DEVICE_RATIO,
DOWN_CONFIG,
UP_CONFIG
}
}
}



// WEBPACK FOOTER //
// ./src/components/financial/AmountDue.vue